import type {
  CharacterConfig,
  HairstyleKey,
  HelmetKey,
  OutfitPatternKey,
} from '../types';

export const HAIRSTYLES: HairstyleKey[] = [
  'short',
  'long',
  'ponytail',
  'curly',
  'braid',
  'bun',
  'mohawk',
  'pigtails',
  'buzz',
  'bob',
];

export const HAIRSTYLE_LABEL: Record<HairstyleKey, string> = {
  short: 'Short',
  long: 'Long',
  ponytail: 'Ponytail',
  curly: 'Curly',
  braid: 'Braid',
  bun: 'Bun',
  mohawk: 'Mohawk',
  pigtails: 'Pigtails',
  buzz: 'Buzz',
  bob: 'Bob',
};

export const HAIR_COLORS: number[] = [
  0x2b1d0e, // black-brown
  0x6b3e1a, // brown
  0xc97a3a, // ginger
  0xeacf8c, // blonde
  0xb0b0b0, // silver
  0xe05a8c, // pink
];

export const EYE_COLORS: number[] = [
  0x3d6cb9, // blue
  0x4a8a3a, // green
  0x6b3a1a, // brown
  0x8a8a8a, // grey
  0x6b3aa8, // violet
];

export const SKIN_TONES: number[] = [
  0xf2cfae,
  0xe2b28a,
  0xc78f64,
  0xa06a40,
  0x6e4423,
];

export const HELMETS: HelmetKey[] = ['none', 'riding', 'jockey', 'cowboy', 'knight'];

export const HELMET_LABEL: Record<HelmetKey, string> = {
  none: 'No Hat',
  riding: 'Riding Helmet',
  jockey: 'Jockey Cap',
  cowboy: 'Cowboy Hat',
  knight: 'Knight Helm',
};

export const OUTFIT_PATTERNS: OutfitPatternKey[] = [
  'solid',
  'stripes',
  'polkadot',
  'plaid',
];

export const OUTFIT_PATTERN_LABEL: Record<OutfitPatternKey, string> = {
  solid: 'Solid',
  stripes: 'Stripes',
  polkadot: 'Polka Dot',
  plaid: 'Plaid',
};

export const OUTFIT_COLORS: number[] = [
  0xc23b3b, // red
  0x2f6fbb, // blue
  0x3a8a3a, // green
  0xe0a830, // gold
  0x6b3aa8, // purple
  0x2c2c2c, // charcoal
];

export const DEFAULT_CHARACTER: CharacterConfig = {
  hairstyle: 'ponytail',
  hairColor: HAIR_COLORS[1],
  eyeColor: EYE_COLORS[0],
  skinTone: SKIN_TONES[1],
  helmet: 'riding',
  outfitPattern: 'solid',
  outfitPrimary: OUTFIT_COLORS[0],
  outfitSecondary: OUTFIT_COLORS[5],
};

// Which hair parts are hidden when wearing a given helmet.
// Each helmet declares whether it covers the top of the head (most styles)
// and whether it allows long/back hair to remain visible behind it.
export const HELMET_COVERAGE: Record<HelmetKey, { hidesTop: boolean; allowsBackHair: boolean }> = {
  none: { hidesTop: false, allowsBackHair: true },
  riding: { hidesTop: true, allowsBackHair: true },
  jockey: { hidesTop: true, allowsBackHair: true },
  cowboy: { hidesTop: true, allowsBackHair: true },
  knight: { hidesTop: true, allowsBackHair: false },
};
